import { Component, Input } from "@angular/core";
import { ModalController } from "@ionic/angular";
import SwiperCore, { SwiperOptions, Zoom } from "swiper";
SwiperCore.use([Zoom]);
@Component({
  selector: "app-image-preview",
  templateUrl: "./image-preview.component.html",
  styleUrls: ["./image-preview.component.scss"],
})
export class ImagePreviewComponent {
  constructor(public modalController: ModalController) {}

  @Input()
  src: string;

  @Input()
  qrCode: string;

  config: SwiperOptions = {
    zoom: true
  }

  goBack() {
    this.modalController.dismiss();
  }
}